'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserService = function () {
  function UserService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UserService);
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(UserService, [{
    key: 'loadDashoardPanelData',
    value: function loadDashoardPanelData(panel, entityId, userId, isManager, userIdOverride, selectedDate, page) {
      var url = this.appConfig.apiServiceBaseUri + ('api/user/' + panel + '/' + entityId);

      if (isManager && userIdOverride) {
        url += '/' + (userIdOverride || userId);

        if (selectedDate) {
          url += '/' + selectedDate.toUniversalFormat();
        }
      } else {
        url += '/' + (isManager ? null : userId);

        if (selectedDate) {
          url += '/' + selectedDate.toUniversalFormat();
        }
      }

      if (page) {
        url += '/' + page;
      }

      return this.$http.get(url);
    }
  }, {
    key: 'promisesStats',
    value: function promisesStats(entityId, userId, isManager, userIdOverride, selectedDate) {
      return this.loadDashoardPanelData('stats/promises', entityId, userId, isManager, userIdOverride, selectedDate);
    }
  }, {
    key: 'promises',
    value: function promises(entityId, userId, isManager, userIdOverride, selectedDate, page) {
      return this.loadDashoardPanelData('promises', entityId, userId, isManager, userIdOverride, selectedDate, page);
    }
  }, {
    key: 'recentContacts',
    value: function recentContacts(entityId, userId, isManager, userIdOverride) {
      return this.loadDashoardPanelData('recentcontacts', entityId, userId, isManager, userIdOverride);
    }
  }, {
    key: 'openEnquiriesStats',
    value: function openEnquiriesStats(entityId, userId, isManager, userIdOverride) {
      return this.loadDashoardPanelData('stats/openenquiries', entityId, userId, isManager, userIdOverride);
    }
  }, {
    key: 'openEnquiries',
    value: function openEnquiries(entityId, userId, isManager, userIdOverride, page) {
      return this.loadDashoardPanelData('openenquiries', entityId, userId, isManager, userIdOverride, null, page);
    }
  }, {
    key: 'openFinancesStats',
    value: function openFinancesStats(entityId, userId, isManager, userIdOverride) {
      return this.loadDashoardPanelData('stats/openfinances', entityId, userId, isManager, userIdOverride);
    }
  }, {
    key: 'openFinances',
    value: function openFinances(entityId, userId, isManager, userIdOverride, page) {
      return this.loadDashoardPanelData('openfinances', entityId, userId, isManager, userIdOverride, null, page);
    }
  }, {
    key: 'pendingDeliveriesStats',
    value: function pendingDeliveriesStats(entityId, userId, isManager, userIdOverride, selectedDate) {
      return this.loadDashoardPanelData('stats/pendingdeliveries', entityId, userId, isManager, userIdOverride, selectedDate);
    }
  }, {
    key: 'pendingDeliveries',
    value: function pendingDeliveries(entityId, userId, isManager, userIdOverride, selectedDate, page) {
      return this.loadDashoardPanelData('pendingdeliveries', entityId, userId, isManager, userIdOverride, selectedDate, page);
    }
  }, {
    key: 'salesMatches',
    value: function salesMatches(entityId, userId, isManager, userIdOverride) {
      return this.loadDashoardPanelData('salesmatches', entityId, userId, isManager, userIdOverride);
    }
  }, {
    key: 'webEnquiriesStats',
    value: function webEnquiriesStats(entityId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/stats/webenquiries/' + entityId));
    }
  }, {
    key: 'webEnquiries',
    value: function webEnquiries(entityId, page) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/webenquiries/' + entityId + '/' + page));
    }
  }, {
    key: 'expiringContactsStats',
    value: function expiringContactsStats(entityId, userId, isManager, userIdOverride) {
      return this.loadDashoardPanelData('stats/expiringcontacts', entityId, userId, isManager, userIdOverride);
    }
  }, {
    key: 'expiringContacts',
    value: function expiringContacts(entityId, userId, isManager, userIdOverride, page) {
      return this.loadDashoardPanelData('expiringcontacts', entityId, userId, isManager, userIdOverride, null, page);
    }
  }, {
    key: 'getLocationUsers',
    value: function getLocationUsers(entityId, includeCurrent, workType) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/location/' + entityId + '/' + (includeCurrent ? includeCurrent : 'null') + '/' + workType));
    }
  }, {
    key: 'getEntityUsers',
    value: function getEntityUsers(locationIds) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/entityusers/' + locationIds));
    }
  }, {
    key: 'getUserStats',
    value: function getUserStats(entityId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/user/userstats/' + entityId));
    }
  }]);
  return UserService;
}();

exports.default = UserService;


// WEBPACK FOOTER //
// ./client/app/components/user/user.service.js